import {
  fetchHolidays,
  HolidaysListQueryParams as HolidayEventListQueryParams,
} from '@nextforce/api'
import { useQuery } from '@tanstack/react-query'
import { useServer } from 'app/server/context'
import { useStores } from 'stores/queries/list'
import { useUser } from 'users/queries/detail'
import keys from './shared/keys'

export function useHolidayEventList(
  params?: HolidayEventListQueryParams | undefined
) {
  const { server } = useServer()
  const { data: stores } = useStores(data => data.stores)
  const { data: user } = useUser()

  return useQuery({
    queryKey: params ? keys.list(params) : [],
    queryFn: fetch,
    enabled: !!user && !!stores && !!params?.storeId,
  })

  function fetch() {
    return fetchHolidays(server, params)
  }
}
